import type { AttendanceStatus, GradeType, UserRole } from '@/types'

export const ATTENDANCE_STATUSES: AttendanceStatus[] = ['H', 'S', 'I', 'A']

export const ATTENDANCE_LABELS: Record<AttendanceStatus, string> = {
    H: 'Hadir',
    S: 'Sakit',
    I: 'Izin',
    A: 'Alpa'
}

export const GRADE_TYPES: GradeType[] = ['harian', 'ulangan', 'tengah', 'akhir']

export const GRADE_TYPE_LABELS: Record<GradeType, string> = {
    harian: 'Tugas Harian',
    ulangan: 'Ulangan',
    tengah: 'Tengah Semester',
    akhir: 'Akhir Semester'
}

export const ROLE_LABELS: Record<UserRole, string> = {
    admin: 'Admin',
    guru: 'Guru'
}

export const DEFAULT_KKM = 75

export const MIN_LOGO_SIZE = 28

export const MAX_LOGO_SIZE = 64
